module.exports = __webpack_public_path__ + "img/6_no.78146521.svg";